/**
 * Kinetics motion helpers for the Shopify theme.
 * Magnetic buttons, card tilt, cart count bump.
 */
(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function bindOnce(el, key) {
    if (!el || el.dataset[key]) return false;
    el.dataset[key] = 'true';
    return true;
  }

  /* Magnetic Button — cursor pulls the control toward it */
  function bindMagnet(zone, el, pull) {
    if (!bindOnce(el, 'kineticsMagnet')) return;
    el.classList.add('kinetics-magnet');
    const strength = pull == null ? 0.28 : pull;

    zone.addEventListener('mousemove', (event) => {
      const rect = el.getBoundingClientRect();
      const x = event.clientX - (rect.left + rect.width / 2);
      const y = event.clientY - (rect.top + rect.height / 2);
      el.style.transform = `translate(${x * strength}px, ${y * strength}px)`;
    });
    zone.addEventListener('mouseleave', () => {
      el.style.transform = 'translate(0, 0)';
    });
  }

  function initMagnets(root) {
    if (reduceMotion || !finePointer) return;
    $$('.banner__buttons, .collection__view-all', root).forEach((zone) => {
      $$('.button', zone).forEach((el) => bindMagnet(zone, el));
    });
  }

  /* Parallax tilt on product cards */
  function bindTilt(wrap) {
    if (!bindOnce(wrap, 'kineticsTilt')) return;
    wrap.style.perspective = '800px';

    wrap.addEventListener('mousemove', (event) => {
      const rect = wrap.getBoundingClientRect();
      const px = (event.clientX - rect.left) / rect.width;
      const py = (event.clientY - rect.top) / rect.height;
      wrap.style.transform = `translateY(-0.8rem) rotateX(${(py - 0.5) * -8}deg) rotateY(${(px - 0.5) * 8}deg)`;
    });

    wrap.addEventListener('mouseleave', () => {
      wrap.style.transform = '';
    });
  }

  function initTilts(root) {
    if (reduceMotion || !finePointer) return;
    $$('.product-card-wrapper.kinetics-card', root).forEach(bindTilt);
  }

  /* Number Counter bump on cart badge */
  function initCartBump() {
    if (reduceMotion) return;
    const cart = document.getElementById('cart-icon-bubble');
    if (!cart || cart.dataset.kineticsCart) return;
    cart.dataset.kineticsCart = 'true';

    const bump = () => {
      const bubble = cart.querySelector('.cart-count-bubble');
      if (!bubble) return;
      bubble.classList.remove('kinetics-bump');
      void bubble.offsetWidth;
      bubble.classList.add('kinetics-bump');
      window.setTimeout(() => bubble.classList.remove('kinetics-bump'), 400);
    };

    const observer = new MutationObserver(bump);
    observer.observe(cart, { childList: true, subtree: true, characterData: true });
  }

  /* Momentum marquee — duplicate groups until the track outruns the viewport */
  const MAX_MARQUEE_GROUPS = 24;

  function fillMarquee(track) {
    const source = track.querySelector('[data-kinetics-marquee-source]');
    if (!source) return;

    $$('[data-kinetics-marquee-clone]', track).forEach((clone) => clone.remove());

    const groupWidth = source.getBoundingClientRect().width;
    const viewport = track.parentElement.getBoundingClientRect().width;
    if (!groupWidth || !viewport) return;

    let count = $$('.kinetics-marquee__group', track).length;
    while (groupWidth * count < viewport * 2 && count < MAX_MARQUEE_GROUPS) {
      const clone = source.cloneNode(true);
      clone.removeAttribute('data-kinetics-marquee-source');
      clone.setAttribute('data-kinetics-marquee-clone', '');
      track.appendChild(clone);
      count += 1;
    }

    track.style.setProperty('--kinetics-marquee-groups', count);
  }

  function initMarquees(root) {
    if (reduceMotion) return;
    $$('.kinetics-marquee__track', root).forEach((track) => {
      fillMarquee(track);
      if (!bindOnce(track, 'kineticsMarquee')) return;

      let resizeTimer;
      window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(() => fillMarquee(track), 150);
      });

      // Web fonts land after first paint and change how wide each group is.
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => fillMarquee(track));
      }
    });
  }

  function init(root = document) {
    initMagnets(root);
    initTilts(root);
    initCartBump();
    initMarquees(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
